import { defineMessages } from 'react-intl';

export default defineMessages({
	title: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.title',
		defaultMessage: 'Name your first project',
		description:
			'Title for page one of the modal. This modal is introduced to admins of a TMP project, to explain the hierarchy of Epics and Issues when they first land on the Board.',
	},
	bodyLineOne: {
		// ID retains `-variation` suffix from shipped JFIND-1968 to avoid retranslation
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.body-line-one-variation',
		defaultMessage:
			"This is where you'll help your team track progress, stay organized, and manage tasks.",
		description:
			'The main text content within page one of the modal. This modal is introduced to admins of a TMP space, to explain the hierarchy of Epics and Issues when they first land on the Board.',
	},
	projectFormField: {
		// ID retains `-variation` suffix from shipped JFIND-1968 to avoid retranslation
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.project-form-field-variation',
		defaultMessage: 'Name your space',
		description: 'The label for the project name field within the project name and icon form.',
	},
	spaceHeader: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.space-header',
		defaultMessage: 'Name your space',
		description: 'Header for the space name step',
	},
	getStartedBtn: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.get-started-btn',
		defaultMessage: 'Get started',
		description: 'Button to create issues and get started',
	},
	skipWizardBtn: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.skip-wizard-btn',
		defaultMessage: 'Skip for now',
		description: 'Button to skip wizard',
	},
	projectNamePlaceholder: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.project-name-placeholder',
		defaultMessage: 'e.g. {projectName}',
		description:
			'Short form of "example" followed by the project name to be used as the placeholder text',
	},
	projectNameMinCharacterLengthError: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.min-character-length-error',
		defaultMessage:
			'Too short (min. {minCharacters} {minCharacters, plural, one {character} other {characters}})',
		description:
			'Error that shows when the user has not typed enough characters for their project or space name.',
	},
	projectNameMaxCharacterLengthError: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.max-character-length-error',
		defaultMessage:
			'Too long (max. {maxCharacters} {maxCharacters, plural, one {character} other {characters}})',
		description:
			'Error that shows when the user has typed too many characters for their project or space name.',
	},
	projectExampleHeading: {
		// ID retains `-variation` suffix from shipped JFIND-1968 to avoid retranslation
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.project-example-heading-variation',
		defaultMessage: 'Example space names:',
		description: 'Title of a section that contains examples of what to name Jira spaces.',
	},
	projectExamples: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-oneproject-examples',
		defaultMessage: 'Team Astro, Visual upgrade, Bug tracking, Product launch',
		description:
			'Some examples of Jira project names that customer can use to help them name their project.',
	},

	// Team-specific Jira space name examples
	// Software team examples
	softwareExample1: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.software-example-1',
		defaultMessage: 'My Software Team',
		description: 'First example space name for software development teams',
	},
	softwareExample2: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.software-example-2',
		defaultMessage: 'Team Astro',
		description: 'Second example space name for software development teams',
	},
	softwareExample3: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.software-example-3',
		defaultMessage: 'Front-End Dev',
		description: 'Third example space name for software development teams',
	},
	softwareExample4: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.software-example-4',
		defaultMessage: 'QA Testing',
		description: 'Fourth example space name for software development teams',
	},
	softwareExample5: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.software-example-5',
		defaultMessage: 'Bug Tracking',
		description: 'Fifth example space name for software development teams',
	},

	// Product Management team examples
	pmExample1: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.pm-example-1',
		defaultMessage: 'My PM Team',
		description: 'First example space name for product management teams',
	},
	pmExample2: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.pm-example-2',
		defaultMessage: 'Team Astro',
		description: 'Second example space name for product management teams',
	},
	pmExample3: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.pm-example-3',
		defaultMessage: 'Roadmap Planning',
		description: 'Third example space name for product management teams',
	},
	pmExample4: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.pm-example-4',
		defaultMessage: 'Product MVPs',
		description: 'Fourth example space name for product management teams',
	},
	pmExample5: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.pm-example-5',
		defaultMessage: 'Launch Planning',
		description: 'Fifth example space name for product management teams',
	},

	// Marketing team examples
	marketingExample1: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.marketing-example-1',
		defaultMessage: 'My Marketing Team',
		description: 'First example space name for marketing teams',
	},
	marketingExample2: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.marketing-example-2',
		defaultMessage: 'Team Vega',
		description: 'Second example space name for marketing teams',
	},
	marketingExample3: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.marketing-example-3',
		defaultMessage: 'Campaign Tracker',
		description: 'Third example space name for marketing teams',
	},
	marketingExample4: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.marketing-example-4',
		defaultMessage: 'Marketing Event Planning',
		description: 'Fourth example space name for marketing teams',
	},
	marketingExample5: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.marketing-example-5',
		defaultMessage: 'Content Pipeline',
		description: 'Fifth example space name for marketing teams',
	},

	// Design team examples
	designExample1: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.design-example-1',
		defaultMessage: 'My Design Team',
		description: 'First example space name for design teams',
	},
	designExample2: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.design-example-2',
		defaultMessage: 'Team Nebula',
		description: 'Second example space name for design teams',
	},
	designExample3: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.design-example-3',
		defaultMessage: 'App Redesign',
		description: 'Third example space name for design teams',
	},
	designExample4: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.design-example-4',
		defaultMessage: 'Visual Design Refresh',
		description: 'Fourth example space name for design teams',
	},
	designExample5: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.design-example-5',
		defaultMessage: 'Design Requests',
		description: 'Fifth example space name for design teams',
	},

	// Project Management team examples
	projectManagementExample1: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.project-management-example-1',
		defaultMessage: 'My Project Management Team',
		description: 'First example space name for project management teams',
	},
	projectManagementExample2: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.project-management-example-2',
		defaultMessage: 'Team Lyra',
		description: 'Second example space name for project management teams',
	},
	projectManagementExample3: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.project-management-example-3',
		defaultMessage: 'Milestone Hub',
		description: 'Third example space name for project management teams',
	},
	projectManagementExample4: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.project-management-example-4',
		defaultMessage: 'Initiative Planning',
		description: 'Fourth example space name for project management teams',
	},
	projectManagementExample5: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.project-management-example-5',
		defaultMessage: 'Cross-Team Projects',
		description: 'Fifth example space name for project management teams',
	},

	// Operations team examples
	operationsExample1: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.operations-example-1',
		defaultMessage: 'My Operations Team',
		description: 'First example space name for operations teams',
	},
	operationsExample2: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.operations-example-2',
		defaultMessage: 'Team Solaris',
		description: 'Second example space name for operations teams',
	},
	operationsExample3: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.operations-example-3',
		defaultMessage: 'Efficiency Tracker',
		description: 'Third example space name for operations teams',
	},
	operationsExample4: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.operations-example-4',
		defaultMessage: 'Compliance Projects',
		description: 'Fourth example space name for operations teams',
	},
	operationsExample5: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.operations-example-5',
		defaultMessage: 'Reporting Dashboards',
		description: 'Fifth example space name for operations teams',
	},

	// IT Support team examples
	itSupportExample1: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.it-support-example-1',
		defaultMessage: 'My IT Team',
		description: 'First example space name for IT support teams',
	},
	itSupportExample2: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.it-support-example-2',
		defaultMessage: 'IT Helpdesk',
		description: 'Second example space name for IT support teams',
	},
	itSupportExample3: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.it-support-example-3',
		defaultMessage: 'Systems Maintenance',
		description: 'Third example space name for IT support teams',
	},
	itSupportExample4: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.it-support-example-4',
		defaultMessage: 'Service Requests',
		description: 'Fourth example space name for IT support teams',
	},
	itSupportExample5: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.it-support-example-5',
		defaultMessage: 'Support Hub',
		description: 'Fifth example space name for IT support teams',
	},

	// HR team examples
	hrExample1: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.hr-example-1',
		defaultMessage: 'My HR Team',
		description: 'First example space name for HR teams',
	},
	hrExample2: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.hr-example-2',
		defaultMessage: 'Team Celeste',
		description: 'Second example space name for HR teams',
	},
	hrExample3: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.hr-example-3',
		defaultMessage: 'People Operations',
		description: 'Third example space name for HR teams',
	},
	hrExample4: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.hr-example-4',
		defaultMessage: 'Employee Programs',
		description: 'Fourth example space name for HR teams',
	},
	hrExample5: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.hr-example-5',
		defaultMessage: 'Talent & Onboarding',
		description: 'Fifth example space name for HR teams',
	},

	// Customer Service team examples
	customerServiceExample1: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.customer-service-example-1',
		defaultMessage: 'My Customer Service Team',
		description: 'First example space name for customer service teams',
	},
	customerServiceExample2: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.customer-service-example-2',
		defaultMessage: 'Team Cosmos',
		description: 'Second example space name for customer service teams',
	},
	customerServiceExample3: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.customer-service-example-3',
		defaultMessage: 'Support Queue',
		description: 'Third example space name for customer service teams',
	},
	customerServiceExample4: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.customer-service-example-4',
		defaultMessage: 'Customer Insights',
		description: 'Fourth example space name for customer service teams',
	},
	customerServiceExample5: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.customer-service-example-5',
		defaultMessage: 'Knowledge Base',
		description: 'Fifth example space name for customer service teams',
	},

	// Legal team examples
	legalExample1: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.legal-example-1',
		defaultMessage: 'My Legal Team',
		description: 'First example space name for legal teams',
	},
	legalExample2: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.legal-example-2',
		defaultMessage: 'Team Eclipse',
		description: 'Second example space name for legal teams',
	},
	legalExample3: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.legal-example-3',
		defaultMessage: 'Compliance & Risk',
		description: 'Third example space name for legal teams',
	},
	legalExample4: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.legal-example-4',
		defaultMessage: 'Legal Operations',
		description: 'Fourth example space name for legal teams',
	},
	legalExample5: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.legal-example-5',
		defaultMessage: 'Policy Reviews',
		description: 'Fifth example space name for legal teams',
	},

	// Finance team examples
	financeExample1: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.finance-example-1',
		defaultMessage: 'My Finance Team',
		description: 'First example space name for finance teams',
	},
	financeExample2: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.finance-example-2',
		defaultMessage: 'Team Nova',
		description: 'Second example space name for finance teams',
	},
	financeExample3: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.finance-example-3',
		defaultMessage: 'Reimbursement Tracking',
		description: 'Third example space name for finance teams',
	},
	financeExample4: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.finance-example-4',
		defaultMessage: 'Budget Tracker',
		description: 'Fourth example space name for finance teams',
	},
	financeExample5: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.finance-example-5',
		defaultMessage: 'Performance Reporting',
		description: 'Fifth example space name for finance teams',
	},

	// Sales team examples
	salesExample1: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.sales-example-1',
		defaultMessage: 'My Sales Team',
		description: 'First example space name for sales teams',
	},
	salesExample2: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.sales-example-2',
		defaultMessage: 'Team Zodiac',
		description: 'Second example space name for sales teams',
	},
	salesExample3: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.sales-example-3',
		defaultMessage: 'Account Planning',
		description: 'Third example space name for sales teams',
	},
	salesExample4: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.sales-example-4',
		defaultMessage: 'Sales Strategy Planning',
		description: 'Fourth example space name for sales teams',
	},
	salesExample5: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.sales-example-5',
		defaultMessage: 'Pipeline Reviews',
		description: 'Fifth example space name for sales teams',
	},

	// Data Science team examples
	dataScienceExample1: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.data-science-example-1',
		defaultMessage: 'My Data Science Team',
		description: 'First example space name for data science teams',
	},
	dataScienceExample2: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.data-science-example-2',
		defaultMessage: 'Team Pulsar',
		description: 'Second example space name for data science teams',
	},
	dataScienceExample3: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.data-science-example-3',
		defaultMessage: 'Analytics Hub',
		description: 'Third example space name for data science teams',
	},
	dataScienceExample4: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.data-science-example-4',
		defaultMessage: 'Data Cleaning',
		description: 'Fourth example space name for data science teams',
	},
	dataScienceExample5: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.data-science-example-5',
		defaultMessage: 'Dashboards & Reporting',
		description: 'Fifth example space name for data science teams',
	},

	// Other team examples
	otherExample1: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.other-example-1',
		defaultMessage: 'My Team',
		description: 'First example space name for other teams',
	},
	otherExample2: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.other-example-2',
		defaultMessage: 'Team Luna',
		description: 'Second example space name for other teams',
	},
	otherExample3: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.other-example-3',
		defaultMessage: 'Task Tracking',
		description: 'Third example space name for other teams',
	},
	otherExample4: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.other-example-4',
		defaultMessage: 'Budget Planning',
		description: 'Fourth example space name for other teams',
	},
	otherExample5: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.other-example-5',
		defaultMessage: 'Big Idea Launch',
		description: 'Fifth example space name for other teams',
	},
});
